import FlexPane from './_flex-pane.js'
import FlexPaneSeparator from './_flex-pane-separator.js'
import SingleBet from './_single-bet.js'

export default {
  name: 'SingleBetsList',
  values: {
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
        },
      },
    },
    separator: {
      configSet: FlexPaneSeparator,
      configValues: {
        style: {
          margin: '0 8px',
          size: '1px',
        },
      },
    },
    singleBet: {
      configSet: SingleBet,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
